// extracted by mini-css-extract-plugin
export default {"boxActionButtons":"BoxActionButtons_boxActionButtons__HMqnL"};